import GlideCarousel from '@/js/glide-carousel';

class ProductImagesCarousel extends GlideCarousel {
  connectedCallback() {
    this.carouselElements = this.querySelectorAll('[data-glide]');
    this.options = {
      type: 'slider',
      gap: 112,
      perView: 1,
      peek: {
        before: 0,
        after: 0
      },
      rewind: false
    };

    super.connectedCallback();

    for (const glideElement of this.glideElements) {
      glideElement.on(['run'], () => {
        this.updateIndex(glideElement.index);
      });
    }
  }

  updateIndex(index) {
    const indexElement = this.querySelector('[data-current-index]');
    if (indexElement) {
      indexElement.textContent = index + 1;
    }
  }
}

customElements.get('product-images-carousel') ||
  customElements.define('product-images-carousel', ProductImagesCarousel);
